import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../_metronic/layout/core'
import * as AllInvoice from './Components/AllInvoice'

const InvoiceBreadCrumbs: Array<PageLink> = [
    {
        title: 'Manage Invoices',
        path: '/invoices/all',
        isSeparator: false,
        isActive: false,
    },
    {
        title: '',
        path: '',
        isSeparator: true,
        isActive: false,
    },
]



const InvoicePage: React.FC = () => {
    return (
        <Switch>




            <Route path='/invoice/all'>
                <PageTitle breadcrumbs={InvoiceBreadCrumbs}>
                    Invoice
                </PageTitle>
                <AllInvoice.AllInvoice />
            </Route>

            <Route path='/invoice/edit/:id'>
                <PageTitle breadcrumbs={InvoiceBreadCrumbs}>Edit Invoice</PageTitle>
                {/* <CreateMenuItem.CreateMenuItem /> */}
            </Route>

            <Route path='/invoice/create'>
                <PageTitle breadcrumbs={InvoiceBreadCrumbs}>Create Invoice</PageTitle>
                {/* <CreateMenuItem.CreateMenuItem /> */}
            </Route>






            <Redirect from='/invoice' exact={true} to='/invoice/all' />
            <Redirect to='/invoice/all' />
        </Switch>
    )
}

export default InvoicePage
